module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2p"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('span', {
    staticClass: "br"
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2pa"
  }, [_vm._v("Uprooted")]), _vm._v(" "), _c('p', {
    staticClass: "h2pc"
  }, [_vm._v("When Life’s Landscape Changes")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I pray that out of his glorious riches he may strengthen you with power through his Spirit in your inner being, so that Christ may dwell in your hearts through faith. And I pray that you, being rooted and established in love, may have power, together with all the Lord’s holy people, to grasp how wide and long and high and deep is the love of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("EPHESIANS 3:16–18")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e05d69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Part01.vue
// module id = 81
// module chunks = 0